<template>
  <div class='have-zoom'>
    <h1>特邀嘉宾管理列表</h1>
    <div class="table">
      <div class="table-head">
        <div class="id">嘉宾ID</div>
        <div class="title">嘉宾名字</div>
        <div class="summary">嘉宾简介</div>
        <!-- <div class="type">活动类型</div> -->
        <select name="type" class="type" v-model="selection">
          <option value="">投放活动</option>
          <option>hkstocks</option>
          <option>freetalks</option>
          <option>roadshow</option>
        </select>
        <div class="city">举办城市</div>
        <div class="active">是否活跃</div>
      </div>
      <div class="table-box">
        <div v-for="(item,index) in tableShow" :key="index" :class="['table-row',item.active===1?'':'noactive-row']">
          <div class="id">
            {{item.id}}
          </div>
          <div class="title">{{item.guName}}</div>
          <div class="summary">{{item.summary}}</div>
          <div class="type">{{item.guType}}</div>
          <div class="city">{{item.guCity}}</div>
          <div :class="['switch',item.active===1?'active-switch':'']" @click="changeActive(item)">
            <div :class="['switch-div',item.active===1?'active-div':'']"></div>
          </div>
          <div class="cheack" @click="editRow(item.id)">查看</div>
        </div>
      </div>
    </div>
    <div class="normal-pagination">
      <el-pagination layout="prev, pager, next" :page-size="10" :total="total" style="float:right" @current-change='changePage'>
      </el-pagination>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableShow: [],
      selectData: [],
      selection: "",
      total: null
    };
  },
  watch: {
    selection() {
      this.select(this.selection);
    }
  },
  methods: {
    select(type) {
      if (!type) {
        this.selectData = [...this.tableData];
      } else {
        this.selectData = [];
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].guType === type) {
            this.selectData.push(this.tableData[i]);
          }
        }
      }
      this.total = this.selectData.length;
      this.changePage(1);
    },
    changeActive(item) {
      let hold = !item.active + 0;
      let form = {
        id: item.id,
        active: hold
      };
      this.$http.guests_active({ ...form }).then(res => {
        if (res.data.statusCode === 200) {
          item.active = hold;
        } else {
          this.$message.error("修改状态未成功");
        }
      });
    },
    changePage(id) {
      const start = (id - 1) * 10;
      const end = start + 10;
      this.tableShow = this.selectData.slice(start, end);
    },
    editRow(id) {
      this.$router.push(`/guest/post/${id}`);
    },
    infoRow(id) {
      this.$router.push(`/sms/guest/${id}`);
    },
    initData() {
      let that = this;
      this.$http.guest_list().then(res => {
        if (res.data.statusCode === 200) {
          this.tableData = res.data.result.reverse();
          this.select();
          this.changePage(1);
        } else {
          this.$message.error("数据请求未成功");
        }
      });
    },
    allUser(type, id) {
      this.$router.push(`/users/${type}/${id}`);
    }
  },
  computed: {},
  mounted() {
    this.initData();
  }
};
</script>

<style scoped>
.el-table__fixed,
.el-table__fixed-right {
  overflow: hidden;
}
div {
  box-sizing: border-box;
}
.table {
  font-family: "Microsoft YaHei";
  color: #878d99;
  width: 100%;
  max-height: 700px;
  font-size: 16px;
  margin-top: 20px;
}
.table-head {
  display: flex;
  width: 95%;
  justify-content: flex-start;
  font-weight: 600;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #ccc;
}

.table-head > div {
  margin-right: 30px;
}
.table-box {
  width: 95%;
  /* display: flex; */
  flex-direction: column;
}
.table-row {
  display: flex;
  /* justify-content: flex-start; */
  height: 60px;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
  transition: background-color 300ms;
  font-size: 14px;
  color: rgb(90, 94, 102);
  align-items: center;
}
.table-row:hover {
  background-color: rgb(236, 245, 255);
}
.table-row > div {
  margin-right: 30px;
}
.noactive-row {
  background-color: #eef0f7;
}
.noactive-row:hover {
  background-color: #dddfe6;
}
.id {
  width: 100px;
  padding-left: 30px;
}
.type,
.city,
.active {
  width: 80px;
}
.title,
.summary,
.link,
.imgUrl {
  width: 200px;
  overflow: hidden;
  word-wrap: break-word;
}
.time {
  min-width: 110px;
  overflow: hidden;
}
.switch {
  margin-left: 20px;
  width: 40px;
  height: 22px;
  border-radius: 15px;
  background-color: rgb(218, 0, 0);
  transition: background-color 400ms;
  cursor: pointer;
}
.active-switch {
  background-color: rgb(0, 202, 216);
}
.switch-div {
  margin: 2px 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #fff;
  transition: transform 400ms;
  transform: translateX(0%);
}
.active-div {
  transform: translateX(100%);
}
.cheack {
  color: rgb(0, 202, 216);
  cursor: pointer;
  margin-left: 10px;
}
.type {
  font-family: "Microsoft YaHei";
  border: none;
  font-size: 16px;
  width: 100px;
  margin-right: 77px !important;
}
.type:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/guest-list.vue